import {
  InternalLinkWrapper,
  InternalLinkStyle
} from './InternalLinkMod.styles';

type OwnProps = {
  isVisible: boolean;
  link: string;
  urlRoot: string;
  title: string;
};

export default function InternalLink({
  isVisible,
  link,
  urlRoot,
  title
}: OwnProps) {
  return (
    <InternalLinkWrapper key={link} isVisible={isVisible}>
      <InternalLinkStyle data-analytics-id={title} href={`${urlRoot}${link}`}>
        {title}
      </InternalLinkStyle>
    </InternalLinkWrapper>
  );
}
